module.exports = __webpack_public_path__ + "img/TemptationLace.6d974ab7.jpg";